// @flow
import React from 'react'
import I18n from 'i18n-react'

// types
import type { ColumnTypeDefaultProps } from '../../Core/Components/_quoteComponents/ColumnTypeDefault'

const ColumnTypeHelpMobile = (props: ColumnTypeDefaultProps) => {
  return ([
    props.data.help && props.data.help.usp && Array.isArray(props.data.help.usp) &&
    props.data.help.usp.map((usp) => [
      <span
        className='badge badge-active-object text-dark text-wrap text-lg-nowrap my-1'
        key={`quote-insuranceCompany-help-badge-mobile-${usp}`}
      >
        {I18n.translate(`quoteHelp.${usp}`)}
      </span>,
      <br key={`${usp}-br`} />
    ]),
  ])
}

export default ColumnTypeHelpMobile
